const header = {
  height: 100,
  heightMobile: 60,
  filters: 66
}

const search = {
  height: header.height + 20,
  heightMobile: header.heightMobile + 10
}

const map = {
  header: header.height + 66,
  headerMobile: header.heightMobile + 72,
  activeFilters: 36,
  activeFiltersMobile: 41,
  listWidthTriple: 1055,
  listWidthDouble: 715,
  listWidthSingle: 375
}

const mapList = {
  headerMobile: map.headerMobile + 57
}

const page = {
  width: 1240
}

const footer = {
  height: 361,
  minimal: {
    height: 62
  }
}

// the metrics above are all wrong for mobile, recalibrated
const mobile = {
  header: 60,
  search: 72,
  actions: 57,
  activeFilters: 32
}

const desktop = {
  search: 72
}

const structure = {
  header,
  search,
  page,
  footer,
  map,
  mapList,
  mobile,
  desktop
}

export default structure
